import { AutogenModelRoutingGuideUserGroups, AutogenRowRoutingGuideUserGroups } from "./autogen/AutogenModelRoutingGuideUserGroups";

export class ModelRoutingGuideUserGroups extends AutogenModelRoutingGuideUserGroups<RowRoutingGuideUserGroups> {
    constructor() {
        super(RowRoutingGuideUserGroups);
    }
}

export class RowRoutingGuideUserGroups extends AutogenRowRoutingGuideUserGroups {
}